<template>
  <div class="mmain">
    <div class="wrapper">
      <div v-for="(item,index) in 1" :key="index">
        <h3>Q：</h3>
        <h4>XXXXXXXXXXXXX</h4>
        <h3>A：</h3>
        <h4>XXXXXXXXXXXXX</h4>
      <div class="line"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nav: [
        { title: "论坛", url: "lt" },
        { title: "问题解答", url: "wtyd" }
      ]
    };
  },
  mounted() {
    // window.scroll(0, 0);
  },
  methods: {},
  components: {
  }
};
</script>
<style lang="less" scoped>
.mmain {
  width: 100%;
  .wrapper {
    width: calc(100vw - 60px);
    margin: 30px auto;
    border-radius: 10px;
    background-color: #fff;
    padding: 30px 0;
    h3 {
      font-size: 16px;
      color: #000;
      font-weight: 700;
      line-height: 1.5;
      width: 90%;
      margin-left: 30px;
    }
    h4 {
      font-size: 14px;
      color: #000;
      line-height: 1.5;
      margin-bottom: 30px;
      width: 90%;
      margin-left: 30px;
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #e6e6e6;
      margin-bottom: 30px;
    }
  }
}
</style>